import React from "react"

import {Barcode, DetailInfoRow} from "~/components/"
import {useTranslation} from "react-i18next"

const BarcodeDetailInfoRow = ({value}) => {
  const {t} = useTranslation()
  return (
    <DetailInfoRow
      label={t("barcode")}
      value={
        <span>
          {value}
          <Barcode
            value={value}
            width={1}
            height={70}
            margin={0}
            displayValue={false}
            background="transparent"
          />
        </span>
      }
    />
  )
}
export default BarcodeDetailInfoRow



// WEBPACK FOOTER //
// ./src/components/decorators/BarcodeDetailInfoRow.js